var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53662 10.2812L0.474121 1.65625C0.310059 1.35156 0.310059 1 0.474121 0.71875C0.638184 0.414062 0.942871 0.25 1.271 0.25L11.396 0.25C11.7476 0.25 12.0522 0.414062 12.2163 0.71875C12.3804 1 12.3804 1.35156 12.2163 1.65625L7.15381 10.2812C6.98975 10.5625 6.68506 10.75 6.3335 10.75C6.00537 10.75 5.70068 10.5625 5.53662 10.2812Z",
    fill: "#F16A81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDownArrow);
export default __webpack_public_path__ + "static/media/red_down_arrow.4934ec059929c9d2a862cabcfae129db.svg";
export { ForwardRef as ReactComponent };